import { Attachment } from "../types/attachment"
import SlideshowModel from "../models/slideshow.model"
import { useReducerAsState } from "./useReducerAsState";

interface SlideshowState {
    loading: boolean;
    error: string | null;
}

const useSlideshow = () => {

    const [state, setState] = useReducerAsState<SlideshowState>({
        loading: false,
        error: null,
    })

    const { loading, error } = state    

    const fetchSlideshow = async (slideshowId: number): Promise<Array<Attachment>> => {
        setState({loading: true})
        const response = await SlideshowModel.find(slideshowId)
        if(!response) {
            setState({loading: false, error: "No se pudo encontrar el slideshow"})
            return []
        }
        setState({loading: false})
        return response.slideshow?.data ?? []
    }

    const saveSlideshow = async (slideshowId: number | undefined, attachments: Array<Attachment>): Promise<number> => {
        setState({loading: true})
        const response = await SlideshowModel.save({slideshowId, attachments})
        if(!response) {
            setState({loading: false, error: "No se pudo guardar el slideshow"})
            return 0
        }
        setState({loading: false})
        return response.slideshow_id ?? 0
    }

    const deleteSlideshow = async (slideshowId: number): Promise<boolean> => {
        setState({loading: true})
        const response = await SlideshowModel.delete(slideshowId)
        if(!response) {
            setState({loading: false, error: "No se pudo eliminar el slideshow"})
            return true
        }
        setState({loading: false})
        return true
    }

    return {
        fetchSlideshow,
        saveSlideshow,
        deleteSlideshow,
        loading, 
        error
    }
}

export default useSlideshow